/* global USATEvents, moment */
$(() => {
  const pluginName = 'usatPlugin';
  const dataKey = `plugin_${pluginName}`;
  const $snackBar = $('[data-js-snack-bar]');
  let settings = {};
  let $pluginContainer = null;
  let plugin = null;
  let $elements;

  const getPersonalInformationField = ($field, personalInformationReference) => {
    if ($field.length) {
      return $field.val();
    }

    if (personalInformationReference) {
      return personalInformationReference;
    }

    return null;
  };

  /**
   * Returns a moment object from the date of birth field
   * @returns {moment}
   */
  const getDateOfBirth = () => moment(
    getPersonalInformationField(
      $elements.personalInformation.dob,
      settings.registrantPersonalInformation.person.dateOfBirth,
    ),
    'YYYY-MM-DD',
  );

  /**
   * Returns the user's age in years
   * @param dateOfBirth
   * @returns {number}
   */
  const getAge = (dateOfBirth) => moment().diff(dateOfBirth, 'years') || 0;

  /**
   * Builds a handy date of birth object
   * @param dateOfBirth
   * @returns {object}
   */
  const buildDateOfBirthObject = (dateOfBirth) => ({
    day: dateOfBirth.date() || '',
    month: dateOfBirth.month() || '',
    year: dateOfBirth.year() || '',
    iso: dateOfBirth.format('YYYY-MM-DD') || '',
    usat: dateOfBirth.format('MMDDYYYY') || '',
    age: getAge(dateOfBirth) || '',
  });

  /**
   * Get the full display text from the selected option in a select (useful when the value is a code or something)
   * @param $select
   * @returns {string}
   */
  const getSelectedOptionText = ($select) => $select.find(':selected').text().trim();

  /**
   * Grabs all the registrant's personal information plus does some formatting to work better with USAT
   * @returns {object}
   */
  const getPersonalInformation = () => {
    const personalInformation = settings.registrantPersonalInformation;

    return {
      usatMemberId: $elements.usat.memberId.val() || 0,
      firstName: getPersonalInformationField(
        $elements.personalInformation.firstName,
        personalInformation.person.firstName,
      ),
      lastName: getPersonalInformationField(
        $elements.personalInformation.lastName,
        personalInformation.person.familyName,
      ),
      address: getPersonalInformationField(
        $elements.personalInformation.address,
        personalInformation.address.address,
      ),
      phone: getPersonalInformationField(
        $elements.personalInformation.phone,
        personalInformation.contactInformation.phoneNumber,
      ),
      city: getPersonalInformationField(
        $elements.personalInformation.city,
        personalInformation.address.city,
      ),
      country: getPersonalInformationField(
        $elements.personalInformation.country,
        personalInformation.address.countryCode,
      ),
      countryFull: getSelectedOptionText($elements.personalInformation.country),
      stateProvince: getPersonalInformationField(
        $elements.personalInformation.subdivisionText,
        personalInformation.address.subdivision,
      ),
      stateProvinceFull: getSelectedOptionText($elements.personalInformation.subdivisionSelect)
                         || $elements.personalInformation.subdivisionText.val(),
      zipPostal: getPersonalInformationField(
        $elements.personalInformation.postalCode,
        personalInformation.address.postalCode,
      ),
      email: getPersonalInformationField(
        $elements.personalInformation.email,
        personalInformation.contactInformation.emailAddress,
      ),
      gender: getPersonalInformationField(
        $elements.personalInformation.gender,
        personalInformation.person.sexCode,
      ),
      genderFull: getSelectedOptionText($elements.personalInformation.gender),
      dob: buildDateOfBirthObject(getDateOfBirth()),
    };
  };

  /**
   * Gets either the memberid or licencecode from USAT
   * @param requestType
   * @returns {*}
   */
  const returnCall = (requestType) => $.ajax({
    url: `${settings.usat.endpoint}/ReturnId.ashx`,
    type: 'GET',
    cache: false,
    async: false,
    contentType: 'application/json',
    data: {
      requestType,
    },
    dataType: 'jsonp',
  }).fail(({ responseText }) => {
    $snackBar.snackBar('add', {
      type: 'danger',
      icon: 'exclamation-circle',
      content: responseText,
    });
  });

  /**
   * Gets the member id from usat then validates
   * @param registrantDetails
   * @param purchaseType
   */
  const getMemberId = (registrantDetails, purchaseType) => {
    returnCall('memberid').done((data) => {
      const memberId = data.memberid || '';
      $elements.usat.memberId.val(memberId);
      $elements.usat.purchaseType.val(purchaseType);

      if (memberId !== '') {
        plugin.validate(memberId, USATEvents.usatEventId, registrantDetails);
      }
    });
  };

  /**
   * Gets the licence code from usat then validates
   * @param registrantDetails
   * @param purchaseType
   */
  const getLicenseCode = (registrantDetails, purchaseType) => {
    returnCall('licensecode').done((data) => {
      const memberId = data.licensecode || '';
      $elements.usat.memberId.val(memberId);
      $elements.usat.purchaseType.val(purchaseType);

      if (memberId !== '') {
        plugin.validate(memberId, USATEvents.usatEventId, registrantDetails);
      }
    });
  };

  /**
   * If we are able to validate, make everything green and pretty and replace the validate button with the clear
   * button
   */
  const validationSuccess = () => {
    $pluginContainer.removeClass('has-error').addClass('has-success');
    $elements.usat.feedback.html(settings.i18n.usat.validated).removeClass('hidden');
    $elements.usat.validateButton.addClass('hidden');
    $elements.usat.clearButton.removeClass('hidden');
  };

  /**
   * If we are not able to validate, make everything red and sad
   * @param error
   */
  const validationFail = (error) => {
    $pluginContainer.removeClass('has-success').addClass('has-error');
    $elements.usat.feedback.html(error).removeClass('hidden');
    $elements.usat.clearButton.addClass('hidden');
    $elements.usat.validateButton.removeClass('hidden');

    if ($elements.usat.storedMemberId.length && $elements.usat.storedMemberId.is(':visible')) {
      $elements.usat.storedMemberId.focus();
    } else {
      $elements.usat.memberId.focus();
    }
  };

  /**
   * Allows the user to clear the validated usat form and try again
   */
  const clearUsat = () => {
    $pluginContainer.removeClass('has-error has-success');
    $elements.usat.validateButton.removeClass('hidden');
    $elements.usat.clearButton.addClass('hidden');
    $elements.usat.feedback.html('').addClass('hidden');
    $elements.usat.storedMemberId.val('');
    $elements.usat.memberId.val('');
  };

  /**
   * Validate against our database record
   * @param memberType
   * @param data
   * @returns {*}
   */
  const validationCall = (memberType, data) => $.ajax({
    url: memberType === 'member' ? USATEvents.api.validateMember : USATEvents.api.validateLicense,
    type: USATEvents.api.v2 ? 'POST' : 'GET',
    data,
  }).done(validationSuccess)
    .fail(({ responseText }) => validationFail(responseText))
    .always(() => $elements.usat.validateButton.html(settings.i18n.usat.validate));

  /**
   * Validate the member against our database record
   * @param memberId
   * @param lastName
   * @param dateOfBirth
   * @returns {*}
   */
  const validateMember = (memberId, lastName, dateOfBirth) => validationCall('member', {
    memberId,
    lastName,
    dateOfBirth,
  });

  /**
   * Validate the license against our database record
   * @param eventId
   * @param memberId
   * @param email
   * @returns {*}
   */
  const validateLicense = (eventId, memberId, email) => validationCall('license', {
    eventId,
    license: memberId,
    email,
  });

  /**
   * We listen to the "message" event and look for membership number
   * @param event
   */
  const receiveMessage = (event) => {
    if (event.origin !== settings.usat.endpoint || !USATEvents.api.v2) {
      return;
    }

    const eventData = event.data;
    if (eventData.action === 'close') {
      if (eventData.member_number) {
        $elements.usat.memberId.val(eventData.member_number);
        $elements.usat.validateButton.trigger('click');
      }

      $elements.usat.modal.modal('hide');
    }
  };

  /**
   * If the user selects a stored membership, update the text field with the ID
   */
  const selectStoredMembership = () => {
    const memberId = $elements.usat.storedMemberId.val();

    if (memberId === 'manual') {
      $elements.usat.memberIdFormGroup.removeClass('hidden');
      $elements.usat.validateButton.removeClass('hidden');
      $elements.usat.purchaseFormGroup.removeClass('hidden');
      $elements.usat.memberId.val('').focus();
    } else {
      $elements.usat.memberIdFormGroup.addClass('hidden');
      $elements.usat.validateButton.addClass('hidden');
      $elements.usat.purchaseFormGroup.addClass('hidden');
      $elements.usat.memberId.val(memberId);
      $elements.usat.purchaseType.val('existing');
    }
  };

  /**
   * When the user submits the form, validate
   * @param event
   */
  const usatFormSubmission = (event) => {
    const memberId = $elements.usat.memberId.val();
    const registrantInformation = getPersonalInformation();

    event.preventDefault();

    plugin.validate(memberId, USATEvents.usatEventId, registrantInformation);
  };

  /**
   * Formats registrant details for use in a query string
   * @param registrantDetails
   * @returns {string}
   */
  const getRegistrantDetailQueryParameters = (registrantDetails) => {
    let queryParameters = `&fname=${registrantDetails.firstName}`;
    queryParameters += `&lname=${registrantDetails.lastName}`;
    queryParameters += `&address=${registrantDetails.address}`;
    queryParameters += `&city=${registrantDetails.city}`;
    // usat isn't cool with the subdivision code
    queryParameters += `&state=${registrantDetails.stateProvinceFull}`;
    // usat isn't cool with spaces in postal codes
    queryParameters += `&zip=${registrantDetails.zipPostal?.replace(' ', '')}`;
    // usat isn't cool with the country code
    queryParameters += `&country=${registrantDetails.countryFull}`;
    // usat isn't cool with our gender code or the full gender, just the first letter
    queryParameters += `&gender=${registrantDetails.genderFull?.substring(0, 1)}`;
    queryParameters += `&dob=${registrantDetails.dob.usat}`;

    return queryParameters;
  };

  /**
   * Builds the iframe url for USAT purchase, with the hope that most of the information is already filled in for them
   * @param memberId
   * @param usatEventId
   * @param registrantDetails
   * @param purchaseOption
   * @param distanceType
   * @param raceType
   * @returns {string}
   */
  const buildIframeUrl = (memberId, usatEventId, registrantDetails, purchaseOption, distanceType, raceType) => {
    const domain = settings.usat.endpoint;
    let type;
    let page;
    let queryString = `email=${registrantDetails.email}`;

    switch (purchaseOption) {
      case 'purchase-membership': {
        page = 'AccountCreation2.aspx';
        type = 1;
        queryString += getRegistrantDetailQueryParameters(registrantDetails);
        break;
      }
      case 'purchase-license': {
        page = 'AccountCreation2.aspx';
        type = 2;
        queryString += getRegistrantDetailQueryParameters(registrantDetails);
        break;
      }
      case 'renew-membership': {
        page = 'Renew.aspx';
        type = 3;
        break;
      }
      case 'upgrade-license': {
        page = 'Upgrade.aspx';
        type = 4;
        queryString += `&LicenseCode=${memberId}`;
        break;
      }
      default: {
        break;
      }
    }

    let types = '';
    if (distanceType !== null && raceType !== null) {
      types = `&race_type=${raceType}&distance_type=${distanceType}`;
    }

    return USATEvents.api.v2
      ? `${domain}/rtav/${usatEventId}/login?mode=tab&return_url=${settings.usat.returnUrl}${types}`
      : `${domain}/${page}?&type=${type}&iFrame=true&EventId=${usatEventId}&${queryString}`;
  };

  /**
   * Do stuff when the usat modal gets closed
   * @param purchaseOption
   * @param registrantDetails
   */
  const usatModalClose = (purchaseOption, registrantDetails) => {
    $elements.usat.iframe.attr('src', '');
    $elements.usat.iframe.html('');
    if (USATEvents.api.v2) {
      return;
    }

    switch (purchaseOption) {
      case 'purchase-membership': {
        getMemberId(registrantDetails, 'annual-purchase');
        break;
      }
      case 'purchase-license': {
        getLicenseCode(registrantDetails, 'one-day-purchase');
        break;
      }
      case 'renew-membership': {
        getMemberId(registrantDetails, 'annual-renewal');
        break;
      }
      case 'upgrade-license': {
        getMemberId(registrantDetails, 'one-day-upgrade');
        break;
      }
      default: {
        break;
      }
    }
  };

  /**
   * When the user clicks one of the purchase dropdown items, bring up the modal and build the relevant iframe
   * @param event
   */
  const purchaseUsat = function purchaseUsat(event) {
    const $this = $(this);
    const registrantDetails = getPersonalInformation();
    const purchaseOption = $this.data('purchase-option');
    const distanceType = $this.data('distance-type') || null;
    const raceType = $this.data('race-type') || null;
    const memberId = $elements.usat.memberId.val();
    const iframeUrl = buildIframeUrl(
      memberId,
      USATEvents.usatEventId,
      registrantDetails,
      purchaseOption,
      distanceType,
      raceType,
    );

    event.preventDefault();

    if (USATEvents.api.v2) {
      window.open(iframeUrl);
    } else {
      $elements.usat.modal.one('hidden.bs.modal', () => usatModalClose(purchaseOption, registrantDetails));
      $elements.usat.modalTitle.text($this.text());
      $elements.usat.iframe.attr('src', iframeUrl);
    }
  };

  /**
   * The user can only choose 1-day option when they're over 18
   */
  const toggleOneDayOption = () => {
    $elements.usat.purchaseDropdownOneDay.toggleClass('hidden', getAge(getDateOfBirth()) < 18);
  };

  /**
   * Attach listeners to everything and do stuff
   */
  const initialize = () => {
    window.addEventListener('message', receiveMessage, false);
    $pluginContainer
      .on('change', settings.selectors.usat.storedMemberId, selectStoredMembership)
      .on('keyup', settings.selectors.usat.memberId, () => $elements.usat.purchaseType.val('manual'))
      .on('click', settings.selectors.usat.validateButton, usatFormSubmission)
      .on('click', settings.selectors.usat.clearButton, clearUsat)
      .on('click', settings.selectors.usat.purchaseDropdownToggle, toggleOneDayOption)
      .on('click', settings.selectors.usat.purchaseDropdownMenuLink, purchaseUsat);
  };

  /**
   * Store lots of jquery objects so we can grab them later without constantly rebuilding them
   */
  const storeElements = () => {
    const $personalInformation = settings.personalInformation.form;

    $elements = {
      usat: {
        memberId: $pluginContainer.find(settings.selectors.usat.memberId),
        memberIdFormGroup: $pluginContainer.find(settings.selectors.usat.memberIdFormGroup),
        storedMemberId: $pluginContainer.find(settings.selectors.usat.storedMemberId),
        purchaseType: $pluginContainer.find(settings.selectors.usat.purchaseType),
        validateButton: $pluginContainer.find(settings.selectors.usat.validateButton),
        clearButton: $pluginContainer.find(settings.selectors.usat.clearButton),
        purchaseFormGroup: $pluginContainer.find(settings.selectors.usat.purchaseFormGroup),
        purchaseDropdownOneDay: $pluginContainer.find(settings.selectors.usat.purchaseDropdownOneDay),
        feedback: $pluginContainer.find(settings.selectors.usat.feedback),
        modal: $(settings.selectors.usat.modal),
        modalTitle: $(settings.selectors.usat.modalTitle),
        iframe: $(settings.selectors.usat.iframe),
      },
      personalInformation: {
        firstName: $personalInformation.find(settings.selectors.personalInformation.firstName),
        lastName: $personalInformation.find(settings.selectors.personalInformation.lastName),
        dob: $personalInformation.find(settings.selectors.personalInformation.dob),
        address: $personalInformation.find(settings.selectors.personalInformation.address),
        phone: $personalInformation.find(settings.selectors.personalInformation.phone),
        city: $personalInformation.find(settings.selectors.personalInformation.city),
        country: $personalInformation.find(settings.selectors.personalInformation.country),
        subdivisionText: $personalInformation.find(settings.selectors.personalInformation.subdivisionText),
        subdivisionSelect: $personalInformation.find(settings.selectors.personalInformation.subdivisionSelect),
        postalCode: $personalInformation.find(settings.selectors.personalInformation.postalCode),
        email: $personalInformation.find(settings.selectors.personalInformation.email),
        gender: $personalInformation.find(settings.selectors.personalInformation.gender),
      },
    };
  };

  /**
   * I'm a plugin!
   * @param element
   * @param options
   * @constructor
   */
  const Plugin = function usatPlugin(element, options) {
    plugin = this;
    this.element = element;
    this.settings = {
      registrationPlugin: null,
      personalInformation: null,
      registrantPersonalInformation: null,
      i18n: {
        usat: {
          validate: null,
          validating: null,
          validated: null,
          validationFailed: null,
        },
      },
      usat: {
        endpoint: null,
        returnUrl: null,
      },
      selectors: {
        usat: {
          memberId: '[name="usat[member_id]"]',
          memberIdFormGroup: '.js-registrant-usat-member-id-form-group',
          storedMemberId: '[name="usat[stored_member_id]"]',
          purchaseType: '[name="usat[purchase_type]"]',
          validateButton: '.js-usat-validate',
          clearButton: '.js-usat-clear',
          purchaseFormGroup: '.js-usat-purchase-form-group',
          purchaseDropdownToggle: '.js-usat-dropdown-toggle',
          purchaseDropdownMenuLink: '.js-usat-dropdown-menu a, .js-usat-purchase-membership',
          purchaseDropdownOneDay: '.js-usat-dropdown-one-day',
          modal: '.js-usat-modal',
          modalTitle: '.js-usat-modal-title',
          iframe: '.js-usat-iframe',
          feedback: '.js-usat-feedback',
        },
        personalInformation: {
          firstName: '[name="registrant[given_name]"]',
          lastName: '[name="registrant[family_name]"]',
          dob: '.js-dob',
          address: '[name="registrant[address]"]',
          phone: '[name="registrant[phone]"]',
          city: '[name="registrant[city]"]',
          country: '[name="registrant[country]"]',
          subdivisionText: '[data-js-geography-subdivision-text]',
          subdivisionSelect: '[data-js-geography-subdivision-select]',
          postalCode: '[name="registrant[postal_code]"]',
          email: '[name="registrant[email]"]',
          gender: '[name="registrant[gender]"]',
        },
      },
    };
    settings = $.extend(true, {}, this.settings, options);
    $pluginContainer = element;

    initialize();
  };

  /**
   * Clear the plugin's contents
   */
  Plugin.prototype.clear = () => {
    $pluginContainer.empty();
  };

  /**
   * Toggle the visibility of this component
   *
   * @param isVisible
   */
  Plugin.prototype.toggleVisibility = (isVisible) => {
    $pluginContainer.toggleClass('hidden', !isVisible);
  };

  /**
   * Display the plugin's contents
   * @param content
   */
  Plugin.prototype.displayContent = (content) => {
    if (content) {
      $pluginContainer.html(content);
    }

    storeElements();
  };

  /**
   * Initialize the functional components of the content
   */
  Plugin.prototype.initializeContent = () => {
    Plugin.prototype.displayContent();
  };

  /**
   * Ask the server if everything looks gucci
   * @param memberId
   * @param eventId
   * @param registrantDetails
   */
  Plugin.prototype.validate = (memberId, eventId, registrantDetails) => {
    if (typeof memberId === 'number'
        || (typeof memberId === 'string' && memberId.length && /^\d+$/.test(memberId))) {
      $elements.usat.validateButton.html(settings.i18n.usat.validating);
      validateMember(memberId, registrantDetails.lastName, registrantDetails.dob.usat);
    } else if (USATEvents.api.v2) {
      validationFail(settings.i18n.usat.invalidMembership);
    } else {
      $elements.usat.validateButton.html(settings.i18n.usat.validating);
      validateLicense(eventId, memberId, registrantDetails.email);
    }
  };

  /**
   * Plugin wrapper, preventing against multiple instantiations and
   * return plugin instance.
   * @param options
   * @returns {usatPlugin|Plugin|*}
   */
  $.fn[pluginName] = function pluginWrapper(options) {
    let thisPlugin = this.data(dataKey);

    // has plugin instantiated ?
    if (thisPlugin instanceof Plugin) {
      // if have options arguments, call plugin.init() again
      if (typeof options !== 'undefined') {
        thisPlugin.init(options);
      }
    } else {
      thisPlugin = new Plugin(this, options);
      this.data(dataKey, thisPlugin);
    }

    return thisPlugin;
  };
});
